<!-- 团体成绩查询 第{{round}}轮 -->
<template>
    <div class="score-table">
        <div >
            {{ errorMessage }}
        </div>  
        <div v-if="isShow">
            <div class="title">团体排名 
                <el-button type="danger"  @click="toggleFullScreen">大屏</el-button> 
            </div>               
            <el-table :data="tableData" class="custom-table custom-table2"
                :row-class-name="tableRowClassName"
                border>
                <el-table-column   
                    v-for="(item, index) in dynamicHeaders"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label" 
                    align="center">
                </el-table-column>               
            </el-table> 
        </div>   
        <!-- <el-button type="primary" @click="printPage">打印页面</el-button> -->
    </div>
 </template>
 
 <script>
import { mapState } from 'vuex'

 export default {
     props:{
        pubId: {
             type: String,
             default: ''
         },
        pubType: {
            type: String,
            default: ''
        }
     },
     data() {
         return {
            activeA: 0,
            activeB: 0,
            dataList: [],
            tableData: [],
            ready: false,
            originPok: [],
            deskNo: 1,
            playersId: 1,
            thingPoker: '',
            northSouthPoker: '',
            showPoker: true,
            isShow: false,
            errorMessage: '',
            tableHeaders: [
                {label: '名次', prop: 'rank'},
                {label: '单位',prop: 'company'},
                {label: '选手', prop: 'username'},
                {label: '搭档名称', prop: 'partnerName'},
                {label: '总积分', prop: 'score'},
                {label: '总胜轮次', prop: 'winNum'},
                {label: '总级差分', prop: 'totalRank'},
                {label: '升级数', prop: 'number'},               
                {label: '对手总分', prop: 'totalPlayers'},
                {label: '对手总级差分', prop: 'totalMinusPlayers'},                
                {label: '搭档总分', prop: 'partnerScore'},
                {label: '搭档总级差分', prop: 'partnerRank'},
            ],
            roundList:[
                {label:1,value:1},
                {label:2,value:2},
                {label:3,value:3},
                {label:4,value:4},
                {label:5,value:5},
                {label:6,value:6},
            ],
            newRound: null,
         }
     },
     created() {
        
     },
     mounted() {
        
     },
     computed:{
        ...mapState(['round']),
     },
     methods: {
        tableRowClassName({row, rowIndex}){
            // 一桌一种颜色
            if(row.rank === 1){
                return 'gold-row'
            }else if(row.rank === 2){
                return  'silver-row'
            }else if(row.rank === 3){
                return  'brown-row'
            }
        },
        // 赛事团体成绩排名              
        initData(){
            let params = {
                opcode: this.$code.GroupRankCode,
                i_serial_mark: this.pubId,
             }            
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    this.newRound = this.round
                    this.isShow = true
                    let result = res.Data.DataTable
                    this.tableData = result.map(item=>{                    
                        return{
                            playersId: item['选手编号'],
                            username: item['选手'],
                            rank: item['名次'],
                            company: item['单位'],
                            score: item['总积分'],
                            winNum: item['总胜轮次'],    
                            number: item['升级数'],                           
                            totalRank: item['总级差分'],
                            totalPlayers: item['对手总分'],
                            totalMinusPlayers: item['对手总级差分'],
                            partnerScore: item['搭档总分'],
                            partnerRank: item['搭档总级差分'],
                            partnerName: item['搭档'],
                            totalScore: item['累计分'],
                        }
                    })    
                    this.errorMessage = ''    
                    let outputArry = this.transformObjectToArray(result[0])    
                // 获取所有唯一的字段名
                const fields = Array.from(new Set(this.tableData.flatMap(Object.keys)));
                // 过滤出至少有一个非空值的字段
                let arr= fields.filter(field => this.tableData.some(row => row[field] !== null && row[field] !== undefined && row[field] !== ''));

                // this.dynamicHeaders = this.tableHeaders.filter(i=>arr.includes(i.prop))
                this.dynamicHeaders = outputArry.filter(i=>arr.includes(i.prop))
                 }else{
                    // this.errorMessage = res.Message
                    this.$message.error(res.Message)
                    this.isShow = false
                 }
             })  
        },
        transformObjectToArray(obj) {
            const result = [];
            const mapping = {
                '名次': 'rank',
                '单位': 'company',
                '选手': 'username',
                '搭档': 'partnerName',                
                '总胜轮次': 'winNum',
                '总级差分': 'totalRank',
                '总积分': 'score',
                '升级数': 'number',
                '对手总分': 'totalPlayers',
                '对手总级差分': 'totalMinusPlayers',
                '搭档总分': 'partnerScore',
                '搭档总级差分': 'partnerRank'
            };        
            for (let key in obj) {
                if (obj.hasOwnProperty(key) && mapping.hasOwnProperty(key)) {                  
                    result.push({
                        label: key,
                        prop: mapping[key]
                    });
                }
            }        
            return result;
        },
        //赛事排名查看 第几轮
        getRoundQuery(round){
            let params = {
                opcode: this.$code.RankRoundQuery,
                i_serial_mark: this.pubId,
                round: this.newRound
             }            
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    this.isShow = true
                    let result = res.Data.DataTable
                    this.tableData  = result.map(item=>{                    
                        return{
                            playersId: item['选手编号'],
                            username: item['选手名称'],
                            rank: item['名次'],
                            score: item['积分'],
                            number: item['升级数'],                           
                            totalRank: item['级差总分'],
                            totalPlayers: item['对手总分'],
                            totalMinusPlayers: item['对手总级差分'],
                            partnerScore: item['搭档总分'],
                            partnerRank: item['搭档总级差分'],
                            partnerName: item['搭档名称'],
                            totalScore: item['累计分'],
                            winNum: item['胜轮次'],    
                            company: item['单位'],                        
                        }
                    })    

                    //  console.log(arr) 
                 }else{
                    this.initData()
                    this.$message.error(res.Message)
                    // this.isShow = false
                 }
             })  
        },
        // 赛事排名保存
        saveRank(){
            let params = {
                opcode: this.$code.SaveRank,
                i_serial_mark: this.pubId,
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                    this.$message.success('保存成功')
                    this.errorMessage = ''
                 }else{
                    this.errorMessage = res.Message
                    this.$message.error(res.Message)
                 }
             })  
        },  
        newUpDownRound(){            
            if(this.newRound > this.round){
                this.$message.error("暂无这一轮成绩")
            }else{
                this.getRoundQuery()
            }
        },
        // 查看上一轮、下一轮的成绩
        upDownRound(value){
           if(value === 1){
            this.newRound = this.round === 1 ? this.round : this.round - 1
            // this.getRoundQuery(this.round - 1)
           }else{
            if(this.newRound === this.round){
                // console.log("111")
                this.$message.error("暂无下一轮成绩")
            }else{
                // console.log("222")
                this.newRound = this.round + 1
                // this.getRoundQuery(this.round + 1)
            }           
           }
        },
         // 本局赛事成绩提交 管理员提交
         scoreSubmit(){
             let params = {
                opcode: this.$code.ScoreOver,
                i_serial_mark: this.pubId,
                i_players_number: this.playersId,
                i_round: this.round,
                i_games_id: 1,
                i_desk_no: this.deskNo,
                thing_poker: this.thingPoker,
                northsouth_poker: this.northSouthPoker,
             }
             console.log(params)
            //  this.$api.requestAPI(params).then(res =>{
            //      if (res.IsSuccess) {
            //         console.log(res)
                                
            //      }
            //  })       
         }, 
        //  本轮赛事完成
         completed(){
             let params = {
                opcode: this.$code.PubComplete,
                i_serial_mark: this.pubId,
                i_round: this.round
             }
             this.$api.requestAPI(params).then(res =>{
                 if (res.IsSuccess) {
                     let result = res.Data.DataTable
                                
                 }
             })       
         }, 
         printPage(){
            // this.$print()
         },
         toggleFullScreen(){
            const routeUrl = this.$router.resolve({ name: 'fullGroupRankQuery', 
            query: { id: this.pubId,type: this.pubType,round: this.newRound} });
            window.open(routeUrl.href, '_blank');   
        },                
     }
 }
 </script>
 <style lang='scss' scoped>
 @import '@/assets/css/style.scss';
 .title{
     font-size: 28px;
     margin-bottom: 10px;
 }
 table {
     width: 100%;
     border-collapse: collapse;
   }
   th, td {
     border: 1px solid #999;
     padding: 8px;
     text-align: left;
     font-size: 28px;
   }
   tr:nth-child(even) {
     background-color: lightblue;
   }
   thead th {
     background-color: #f2f2f2;
     font-size: 30px;
     text-align: center;
   }
   .table-label {
     display: flex;
     justify-content: space-between;
     align-items: center;
     padding: 10px;
     background-color: #f9f9f9;
     border: 1px solid #ddd;
   }
.custom-table >>> .el-table__header-wrapper tr th{
    font-size: 18px;
    color: #333;
}
.custom-table >>> .gold-row{
    background-color: gold;
}
.custom-table >>> .silver-row{
    background-color: #C0C0C0;
}
.custom-table >>> .brown-row{
    background-color: #CD7F32;
}
 </style>


// WEBPACK FOOTER //
// src/views/setting/components/groupRankQuery.vue